import PppLinks from "../../features/ppp-links/PppLinks";

export default function PppLinksPage() {
  return (
    <div>
      <PppLinks />
    </div>
  );
}


